import React from 'react';
import clsx from 'clsx';
import { is } from '../../../services/index';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Navbar component
 * @param children {React.ReactNode} Navbar child
 * @param className {string} Additionnal css classes
 * @param hiddenTouch {boolean} Display modes only: mobile and desktop; use it to manage the responsive
 */
const NavbarMenu = ({ className, hiddenTouch, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('navbar-menu', hiddenTouch && is('hidden-touch'), className));
    return React.createElement("div", { className: classes, ...others });
};
export default NavbarMenu;
//# sourceMappingURL=NavbarMenu.js.map